<div
  class="notifications-menu"
  (clickOutside)="onClose()"
  #menu
>
  <div class="header-box">
    <button
      class="header-box__close-button"
      (click)="toggleNotificationsMenu()"
      aria-label="Close"
    >
      <nb-icon icon="arrow-ios-forward-outline" aria-hidden="true"></nb-icon>
    </button>
    <div class="header-box__title">
      <span class="header-box__title__text">
        {{ "notifications.notifications" | translate }}
      </span>
      <button
        [appPermissionDisabled]="permissions.Notifications.Manage"
        (click)="clearAllNotifications()"
        aria-label="Clear notifications"
      >
        {{ "notifications.clear-all" | translate }}
      </button>
    </div>
  </div>
  <div class="notifications-menu__filters">
    <nb-accordion>
      <nb-accordion-item>
        <nb-accordion-item-header>{{ "common.filters" | translate }}</nb-accordion-item-header>
        <nb-accordion-item-body>
          <div class="filters-item-box">
            <label for="deviceId">{{ "common.device" | translate }}</label>
            <nb-select
              [(selected)]="selectedDeviceId"
              (selectedChange)="onDeviceFilterChange($event)"
              size="small"
              name="deviceId"
              status="primary"
              placeholder="{{ 'common.all' | translate }}"
            >
              <nb-option [value]="-1" click-stop-propagation>
                <span class="text-center"> {{ "common.all" | translate }}</span>
              </nb-option>
              <nb-option
                [value]="device.id"
                *ngFor="let device of availableDevices; trackBy: trackByFn"
                click-stop-propagation
              >
                {{ device.serialNumber }}
              </nb-option>
            </nb-select>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>
    </nb-accordion>
  </div>

  <app-infinite-scroll (scrolled)="onScroll()">
    <div
      class="notification-box--empty"
      *ngIf="webNotifications.length === 0"
      @fadeInOut
    >
      {{ "notifications.empty-notifications" | translate }}
    </div>
    <div
      *ngFor="
        let webNotification of webNotifications;
        trackBy: trackByFn;
        let i = index
      "
      class="notification-box"
      @fadeInOut
      [ngClass]="{
        'notification-box--dangerous':
          +webNotification.type === DeviceNotificationType.ERROR,
        'notification-box--warning':
          +webNotification.type === DeviceNotificationType.WARNING,
        'notification-box--unread': !webNotification.isRead
      }"
    >
      <div class="notification-box__icon">
        <ng-container [ngSwitch]="+webNotification.type">
          <span *ngSwitchCase="DeviceNotificationType.ERROR">
            <nb-icon icon="alert-triangle-outline"></nb-icon>
          </span>
          <span *ngSwitchCase="DeviceNotificationType.WARNING">
            <nb-icon icon="alert-circle-outline"></nb-icon>
          </span>

          <span *ngSwitchCase="DeviceNotificationType.INFO">
            <nb-icon icon="info-outline"></nb-icon>
          </span>
        </ng-container>
      </div>
      <div class="notification-box__content">
        <span class="notification-box__content__title">
          {{ webNotification.message | translate }}
        </span>
        <p class="notification-box__content__desciption"></p>
        <span class="notification-box__content__date">
          {{
            webNotification.createdAt
              | utcToLocaleDateTime : "dd/MM/yyyy HH:mm:ss"
          }}
        </span>
      </div>
      <button
        class="notification-box__delete-notification-button"
        (click)="clearNotification(webNotification)"
        aria-label="Clear notification"
      >
        <nb-icon icon="close-outline" aria-hidden="true"></nb-icon>
      </button>
    </div>
  </app-infinite-scroll>
</div>
